export interface IActiveTermsCulture {
  id: number;
  culture: string;
  cultureDisplayName: string;
  description: string;
}
